import calculateHmac from './calculate-hmac';

export default function calculateDeviceLoginToken(email) {
  return calculateHmac({ email }).slice(0, 30);
}
